import { Suspense, lazy, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import './App.css'

import Navbar from "./components/Navbar/Navbar";
import Profile from "./components/Profile";
import Home from "./components/Home";
import NewsArticle from "./components/NewsArticle";
import NewsPage from "./components/NewsPage";
import AboutUs from "./components/AboutUs";
import WorkInProgress from "./components/WorkInProgress";

const AdminPage = lazy(() => import("./components/Admin/AdminPage"));
const PublishNews = lazy(() => import("./components/Admin/PublishNews"));
const UserManagement = lazy(() => import("./components/Admin/UserManagement"));
const Calendar = lazy(() => import("./components/Admin/Calendar"));
const Analytics = lazy(() => import("./components/Admin/Analytics"));
const NewsManagement = lazy(() => import("./components/Admin/NewsManagement"));
const EditNews = lazy(() => import("./components/Admin/EditNews"));
const Login = lazy(() => import("./components/Admin/Login"));
const ProtectedRoute = lazy(() => import("./components/Admin/ProtectedRoute"));

// Loading component for Suspense fallback
const LoadingComponent = () => (
  <div className="flex items-center justify-center w-full h-[calc(100vh-80px)]">
    <div className="flex flex-col items-center">
      <div className="w-12 h-12 border-t-2 border-b-2 border-blue-500 rounded-full animate-spin"></div>
      <p className="mt-4 text-lg text-gray-700">Loading...</p>
    </div>
  </div>
);

function App() {
  // Add performance measurement for initial page load
  useEffect(() => {
    // This will help identify slow loading components
    const loadTime = performance.now();
    console.log(`Initial page load completed in ${loadTime}ms`);
    
    // Add listener for when everything is fully loaded including images
    window.addEventListener('load', () => {
      const fullLoadTime = performance.now();
      console.log(`Full page load completed in ${fullLoadTime}ms`);
    });
  }, []);

  return (
    <div className="min-h-screen bg-[#f8fafc]">
      <Navbar />
      <div className="">        <Suspense fallback={<LoadingComponent />}>          <Routes>            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/news/:id" element={<NewsArticle />} />
            <Route path="/news" element={<NewsPage />} />
            
            {/* Work in Progress route - needs to be before /:id */}
            <Route path="/wip" element={<WorkInProgress />} />            
            {/* Admin routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route path="/admin" element={<ProtectedRoute><AdminPage /></ProtectedRoute>} />
            <Route path="/admin/news" element={<ProtectedRoute><NewsManagement /></ProtectedRoute>} />
            <Route path="/admin/publish" element={<ProtectedRoute><PublishNews /></ProtectedRoute>} />
            <Route path="/admin/edit-news/:id" element={<ProtectedRoute><EditNews /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute><UserManagement /></ProtectedRoute>} />
            <Route path="/admin/calendar" element={<ProtectedRoute><Calendar /></ProtectedRoute>} />
            <Route path="/admin/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />
            
            {/* Profile route for individual alumni - this should come after specific routes */}
            <Route path="/:id" element={<Profile />} />
            
            {/* Catch-all route - any other path goes to Work in Progress */}
            <Route path="*" element={<WorkInProgress />} />
          </Routes>
        </Suspense>
      </div>
      <Toaster/>
    </div>
  )
}

export default App
